<div id="wrapper">
	<div id="left">
		<input
			type="text"
			ngxDaterangepickerMd
			class="date-range-picker"
			readonly
			[(ngModel)]="selected"
			placeholder="Choose date range"
			[showDropdowns]="true"
			[isInvalidDate]="isInvalidDate"
			[locale]="isR9 ? { format: 'MM/DD/YY' } : { format: 'MM/DD/YYYY' }"
			(datesUpdated)="applyDate($event)"
			showCancel="true"
			(click)="showCalendar($event)"
			[maxDate]="maxDate"
			(blur)="hideCalendar($event)"
		/>
		<span id="errorMessage" class="tooltipText"></span>
	</div>
	<div id="right">
		<span
			class="fa ngx-daterangepicker-action"
			[ngClass]="{ 'fa-angle-down': !isActive, 'fa-angle-up': isActive }"
			(click)="toggleCalendar($event)"
		></span>
	</div>
</div>
